module.exports = __webpack_public_path__ + "static/media/Waterloo.70850ccb.png";